<template>
  <div>
    <div class="graduate-title clearfix">
      <h3>毕业考核</h3>
      <span
        >考核成绩：
        <template v-if="graduateData.graduatescore > 0">
          <b class="color1">{{ graduateData.graduatescore }}</b> 分
        </template>
        <template v-else>--</template>
      </span>
    </div>
    <div class="graduate-thesis">
      <Spin v-if="uploaderLoading" fix>
        <Icon type="ios-loading" size="22" class="spin-icon-load"></Icon>
        <div style="margin-top: 5px">上传中</div>
      </Spin>
      <template v-if="graduateData.status !== 2 && !graduateData.paperurl">
        <Upload
          :action="uploaderConfig.uploaderUrl"
          :headers="uploaderConfig.uploaderHeaer"
          :data="uploaderConfig.uploaderFileData"
          :max-size="1024 * 100"
          :on-exceeded-size="handleMaxSizeError"
          :format="[
            'doc',
            'docx',
            'ppt',
            'pptx',
            'xls',
            'xlsx',
            'zip',
            'rar',
            '7z',
            'pdf',
          ]"
          :on-format-error="handleFormatError"
          :before-upload="handleFileBefore"
          :on-success="handleFileSuccess"
          :show-upload-list="false"
          ref="uploadFile"
        >
          <div class="thesis-uploader">
            <Icon type="md-add" size="32" color="#0192e6" />
            <p>
              请将完成的论文（报考）上传，支持文档格式：doc/ppt/excel/pdf（限100M以内）
            </p>
          </div>
        </Upload>
      </template>
      <template v-else-if="graduateData.status === 2 && !graduateData.paperurl">
        <div class="thesis-uploader">
          <p style="margin-bottom: 30px">未上传考核文件</p>
        </div>
      </template>
      <template v-else>
        <div class="thesis-show">
          <div class="thesis-show-doc">
            <div class="thesis-show-file clearfix">
              <img
                v-if="graduateData.fileType.indexOf('doc') > -1"
                src="../../assets/images/mall/file-doc.png"
              />
              <img
                v-else-if="graduateData.fileType.indexOf('ppt') > -1"
                src="../../assets/images/mall/file-ppt.png"
              />
              <img
                v-else-if="graduateData.fileType.indexOf('xls') > -1"
                src="../../assets/images/mall/file-xls.png"
              />
              <img
                v-else-if="graduateData.fileType.indexOf('pdf') > -1"
                src="../../assets/images/mall/file-pdf.png"
              />
              <img
                v-else-if="
                  graduateData.fileType.indexOf('rar') > -1 ||
                  graduateData.fileType.indexOf('zip') > -1 ||
                  graduateData.fileType.indexOf('7z') > -1
                "
                src="../../assets/images/mall/file-zip.png"
              />
              <img v-else src="../../assets/images/mall/file-no.png" />
              <h5>{{ graduateData.paperurlname }}</h5>
              <p>{{ graduateData.papersize }}</p>
            </div>
            <p v-show="graduateData.status !== 2">
              请将完成的论文（报考）上传，支持文档格式：doc/ppt/excel/pdf（限100M以内）
            </p>
          </div>
          <div class="thesis-show-btn" v-show="graduateData.status !== 2">
            <Button
              type="error"
              size="small"
              shape="circle"
              style="width: 80px; line-height: 1.6; margin-right: 16px"
              @click="deleteFile"
              >删除</Button
            >
            <Upload
              :action="uploaderConfig.uploaderUrl"
              :headers="uploaderConfig.uploaderHeaer"
              :data="uploaderConfig.uploaderFileData"
              :max-size="1024 * 100"
              :on-exceeded-size="handleMaxSizeError"
              :format="[
                'doc',
                'docx',
                'ppt',
                'pptx',
                'xls',
                'xlsx',
                'zip',
                'rar',
                '7z',
                'pdf',
              ]"
              :on-format-error="handleFormatError"
              :before-upload="handleFileBefore"
              :on-success="handleFileSuccess"
              :show-upload-list="false"
              style="display: inline-block"
              ref="uploadFileReset"
            >
              <Button
                type="primary"
                size="small"
                shape="circle"
                style="width: 80px; line-height: 1.6"
                >重新上传</Button
              >
            </Upload>
          </div>
        </div>
      </template>
    </div>
    <div class="graduate-title clearfix">
      <h3>毕业证书/学位证书</h3>
    </div>
    <div class="graduate-cert">
      <div>
        <div class="cert-name">毕业证书</div>
        <div
          class="cert-photo"
          :class="graduateData.status === 2 ? 'yes' : 'no'"
        >
          <template
            v-if="
              graduateData.status === 2 && !graduateData.graduationpapersurl
            "
          >
            <div>
              <img src="../../assets/images/cert-flower.png" />
              <p class="color2">恭喜，您已毕业！</p>
              <p class="color3">请尽快联系班主任领取毕业证~</p>
            </div>
          </template>
          <template
            v-else-if="
              graduateData.status === 2 && graduateData.graduationpapersurl
            "
          >
            <img
              :src="concatImageUrl(graduateData.graduationpapersurl, 320, 180)"
              width="320"
              height="180"
            />
          </template>
          <template v-else>
            <span class="color3">还没有毕业哦~</span>
          </template>
        </div>
        <div
          class="cert-info clearfix"
          v-show="graduateData.status === 2 && graduateData.graduationpapersno"
        >
          <span class="cert-num"
            >证书编号：{{ graduateData.graduationpapersno }}</span
          >
          <span
            class="cert-copy"
            :data-clipboard-text="graduateData.graduationpapersno"
            @click="copyCertNumber()"
            >复制编号</span
          >
        </div>
      </div>
      <div>
        <div class="cert-name">学位证书</div>
        <div
          class="cert-photo"
          :class="graduateData.status === 2 ? 'yes' : 'no'"
        >
          <template
            v-if="graduateData.status === 2 && !graduateData.degreepapersurl"
          >
            <div>
              <img src="../../assets/images/cert-flower.png" />
              <p class="color2">恭喜，您已获得学位！</p>
              <p class="color3">请尽快联系班主任领取学位证~</p>
            </div>
          </template>
          <template
            v-else-if="
              graduateData.status === 2 && graduateData.degreepapersurl
            "
          >
            <img
              :src="concatImageUrl(graduateData.degreepapersurl, 320, 180)"
              width="320"
              height="180"
            />
          </template>
          <template v-else>
            <span class="color3"
              >如需获取学位，请先报考学位英语。<br />详情请联系班主任~</span
            >
          </template>
        </div>
        <div
          class="cert-info clearfix"
          v-show="graduateData.status === 2 && graduateData.degreepapersno"
        >
          <span class="cert-num"
            >证书编号：{{ graduateData.degreepapersno }}</span
          >
          <span
            class="cert-copy"
            :data-clipboard-text="graduateData.degreepapersno"
            @click="copyCertNumber()"
            >复制编号</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { user } from "../../request";
import Clipboard from "clipboard";
export default {
  mixins: [siteMixin],
  props: {
    gradeInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      graduateData: {},
      uploaderConfig: {
        uploaderUrl:
          process.env.VUE_APP_API_URL + "/graduation/uploadGraduateFile",
        uploaderHeaer: {
          Authorization: "Beego aHVhaGFuOmJlZWdvMjAxNQ==",
        },
        uploaderFileData: {
          gradeCode: 0,
          userId: 0,
          id: 0,
        },
      },
      uploaderLoading: false,
    };
  },
  mounted() {
    this.initUploaderData();
    this.getGraduateData();
  },
  methods: {
    getGraduateData() {
      user
        .getGraduateInfo(this.gradeInfo.gradeCode, this.loginUser.userId)
        .then((res) => {
          //console.log("graduateInfo", res);
          if (res.status === 1) {
            this.graduateData = res.data;
          }
        });
    },
    deleteFile() {
      user.deleteGraduateFile(this.graduateData.id).then((res) => {
        if (res.status === 1) {
          this.getGraduateData();
        }
      });
    },
    //初始化资料上传数据
    initUploaderData() {
      this.uploaderConfig.uploaderFileData.gradeCode = this.gradeInfo.gradeCode;
      this.uploaderConfig.uploaderFileData.userId = this.loginUser.userId;
    },
    handleFileBefore(file) {
      if (this.graduateData.id) {
        this.uploaderConfig.uploaderFileData.id = this.graduateData.id;
      }
      this.uploaderLoading = true;
    },
    handleFileSuccess(res) {
      //console.log("frontUploaderSuccess", res);
      if (res.status === 1) {
        this.getGraduateData();
      } else {
        this.$Message.error(res.message);
      }
      this.uploaderLoading = false;
    },
    handleMaxSizeError(file) {
      this.$Message.error("上传文件超过最大上传大小~");
      this.uploaderLoading = false;
    },
    handleFormatError(file) {
      this.$Message.error(
        "文件格式不正确，仅支持 doc/ppt/excel/pdf 格式的文件~"
      );
      this.uploaderLoading = false;
    },
    copyCertNumber() {
      const clipboard = new Clipboard(".cert-copy");
      clipboard.on("success", (e) => {
        console.log(e);
        this.$Message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$Message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var";
.graduate-title {
  border-bottom: 1px solid #ccc;
  padding-bottom: 12px;
  h3 {
    float: left;
  }
  span {
    float: right;
    font-weight: bold;
  }
}
.graduate-thesis {
  position: relative;
  padding: 20px 0;
  .thesis-progress {
    position: absolute;
    left: 0;
    top: 20px;
    width: 100%;
    height: 115px;
    border-radius: 6px;
    padding: 0 20px;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
  }
  .thesis-uploader {
    border: 1px dashed #ccc;
    border-radius: 6px;
    background: #f5f5f5;
    text-align: center;
    padding: 40px 0 10px 0;
    width: 930px;
    p {
      margin-top: 10px;
      color: #999;
    }
  }
  .thesis-show {
    display: flex;
    align-items: center;
    padding: 20px 0;
    .thesis-show-doc {
      flex: 1;
      .thesis-show-file {
        img {
          margin-top: 7px;
          margin-right: 10px;
          float: left;
          width: 32px;
          height: 32px;
          display: block;
        }
        h5 {
          font-size: 15px;
          padding-right: 20px;
          .ellipsis();
        }
        p {
          font-weight: bold;
          padding-top: 2px;
        }
      }
      & > p {
        color: #999;
        margin-top: 5px;
      }
    }
    .thesis-show-btn {
      width: 180px;
    }
  }
}
.graduate-cert {
  width: 870px;
  margin: 30px auto;
  display: flex;
  & > div {
    flex: 1;
    text-align: center;
  }
  .cert-name {
    color: #0a96e7;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .cert-photo {
    width: 320px;
    height: 180px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    &.no {
      border: 1px dashed #ccc;
      border-radius: 6px;
      background: #f5f5f5;
    }
    &.yes {
      border: 1px solid #ccc;
      border-radius: 6px;
    }
    img {
      display: block;
      margin: 0 auto;
      padding-bottom: 5px;
    }
    p {
      margin-top: 5px;
      &:first-of-type {
        font-weight: bold;
      }
    }
  }
  .cert-info {
    width: 320px;
    margin: 10px auto;
    font-weight: bold;
    .cert-num {
      float: left;
    }
    .cert-copy {
      float: right;
      color: #0e90d2;
    }
  }
}
</style>